import { DataSubjectRequestStatus } from './data-subject.models';

/**
 * Os valores vêm do Essentials tal como lá estão. Traduzem-se aqui porque quem trata o pedido
 * de direitos não tem de saber o vocabulário interno do outro sistema.
 */
export const RETENTION_BASIS_LABELS: Record<string, string> = {
  CONSENT: 'Consentimento',
  LEGITIMATE_INTEREST: 'Interesse legítimo',
};

export const CONSENT_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pedido, sem resposta',
  ACCEPTED: 'Concedido',
  DECLINED: 'Recusado',
  DECLINED_NO_RESPONSE: 'Recusado (sem resposta)',
  DECLINED_REQUIRES_REVIEW: 'Recusado, a rever',
  DECLINED_REVIEW_APPROVED: 'Recusado, revisão aprovada',
  DELETED_BY_REFUSAL: 'Dados eliminados por recusa',
  MASKED: 'Dados eliminados',
  EXPIRED: 'Expirado',
};

/** `DataConsentChannelENUM` do Essentials. */
export const CONSENT_CHANNEL_LABELS: Record<string, string> = {
  WEBSITE: 'Site',
  LINKEDIN: 'LinkedIn',
  OTHER_ONLINE_PLATFORM: 'Outra plataforma online',
  JOB_PLATFORM: 'Plataforma de emprego',
  INVITE: 'Convite',
  IN_PERSON_INTERVIEW: 'Entrevista presencial',
};

export const DATA_SUBJECT_REQUEST_STATUS_LABELS: Record<DataSubjectRequestStatus, string> = {
  CONCLUIDO: 'Concluído',
  AGENDADO: 'Agendado',
  RECUSADO: 'Recusado',
  FALHOU: 'Falhou',
};

export const DATA_SUBJECT_REQUEST_STATUS_CLASS: Record<DataSubjectRequestStatus, string> = {
  CONCLUIDO: 'bg-success-soft',
  AGENDADO: 'bg-info-soft',
  RECUSADO: 'bg-warning-soft',
  FALHOU: 'bg-danger-soft',
};

/** Rótulo de um valor que veio do Essentials e ainda não tem tradução: mostra-se como está. */
export function labelOr(labels: Record<string, string>, value: string | null): string {
  if (!value) return '—';
  return labels[value] ?? value;
}
